<template>
  <div class="item-management-wrapper">
    <div class="item-management-wrapper__block mb-16">
      <div class="item-management-wrapper__title">
        <span class="item-management-wrapper__title-icon"><i class="icon-list"></i></span>
        <span>{{ title }}</span>
      </div>
    </div>
    <div class="item-management-wrapper__block justify-between mb-16">
      <div class="item-management-wrapper__container">
        <el-switch
          v-model="isSortActive"
          class="mr-16"
          active-color="#12B3A4"
          :active-text="$t('OrderFoodItemManagement.AdjustOrder')"
        >
        </el-switch>
        <el-button v-show="isSortActive" type="primary" round size="small" @click="$emit('save-order')">
          {{ $t('OrderFoodItemManagement.SaveOrder') }}
        </el-button>
      </div>
      <div class="item-management-wrapper__container">
        <el-button type="primary" round icon="el-icon-plus" :disabled="isSortActive" @click="$emit('create')">
          <span>{{ $t('General.Create') }}{{ btnText }}</span>
        </el-button>
      </div>
    </div>
    <div class="item-management-wrapper__block">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemManagementWrapper',
  props: {
    title: {
      type: String,
      default: '項目管理'
    },
    btnText: {
      type: String,
      default: '新增項目'
    }
  },
  data () {
    return {
      isSortActive: false // 是否排序啟用
    }
  },
  watch: {
    isSortActive (val) {
      this.$emit('sort-active', val)
    }
  },
  methods: {
    // 處理排序啟用
    setSortActive (val) {
      this.isSortActive = val
    }
  }
}
</script>

<style lang="scss" scoped>
.item-management-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    &__block {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        &.justify-between {
            justify-content: space-between;
        }
        @include FoodItemManagement();
    }
    &__container {
        display: flex;
        align-items: center;
    }
    &__title {
        display: flex;
        align-items: center;
        &-icon {
            display: flex;
            align-items: center;
            margin-right: 4px;
        }
    }
}
</style>
